import React, { useState } from 'react';

const Tooltip = ({ children, text, position = 'top' }) => {
  const [show, setShow] = useState(false);

  // Position logic
  const positionClasses = {
    top: "bottom-full mb-2 left-1/2 -translate-x-1/2",
    bottom: "top-full mt-2 left-1/2 -translate-x-1/2",
    left: "right-full mr-2 top-1/2 -translate-y-1/2",
    right: "left-full ml-2 top-1/2 -translate-y-1/2",
  };

  return (
    <div 
      className="relative flex items-center"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      
      {show && (
        <div className={`absolute z-50 px-2 py-1 text-xs text-white bg-gray-800 rounded shadow-sm whitespace-nowrap ${positionClasses[position]}`}>
          {text}
          {/* Optional Arrow */}
          <div className={`absolute w-2 h-2 bg-gray-800 rotate-45 
            ${position === 'top' ? 'top-full -mt-1 left-1/2 -translate-x-1/2' : ''}
            ${position === 'bottom' ? 'bottom-full -mb-1 left-1/2 -translate-x-1/2' : ''}
          `}></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;